module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('a', {
    attrs: {
      "id": "page_ix"
    }
  }), _vm._v(" "), _c('h2', {
    staticClass: "fmtitle"
  }, [_vm._v("Preface")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', {
    staticClass: "dropcaps"
  }, [_vm._v("O")]), _vm._v("ne of the most pleasant rewards for writing history is that you meet delightful people. Another is that you learn fascinating information. In both respects I have been especially fortunate in the contacts I have made and the ‘feedback’ I have received from other admirers of that most interesting of aircraft, the Hawker Hurricane.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("One reason why this cannot help but be interesting is the sheer extent and variety of the service it gave. A few years ago in a book entitled "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Ten Squadrons of Hurricanes")]), _vm._v(" I included accounts of its part in the Battle of France, the Battle of Britain, campaigns in the Western Desert, the Balkans and the Middle East and its role as a night-fighter on the defensive and on intruder missions. Fellow enthusiasts, however, rightly told me I had not covered the Hurricane’s part in campaigns in Norway, Russia, Malta, North Africa, East Africa and the Far East, its role as a naval-air fighter, catapulted from merchant vessels or launched from aircraft carriers, and some aspects of its value in the Battle of Britain.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Here then is my attempt to fill the gaps and show how the Hurricane’s service can truly be called ‘worldwide’. As Denis Richards and Hilary St. G. Saunders declare in the Official History "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Royal Air Force 1939–1945")]), _vm._v(": ‘Everywhere the ubiquitous Hurricane was to be seen.’")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "page_x"
    }
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-152bba99","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/06_Preface.vue
// module id = 75
// module chunks = 0